import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    rating:4.5,
    text:"",
    announce: "",
    author: "",
}

export const commentSlice = createSlice({
  name: 'comment',
  initialState,
  reducers: {
  rate: (state, action) => {
      state.rating = action.payload;
  },
  textComment :(state,action)=>{
    state.text = action.payload
  },
  announceId :(state,action)=>{
    state.announce = action.payload
  },
  authorId :(state,action)=>{
    state.author = action.payload
  }
},
})
export const {rate,textComment,announceId,authorId} = commentSlice.actions

export default commentSlice.reducer


export function fetchRecipes() {
  return async dispatch => {
    dispatch(rate(1))

    try {
      console.log("excuter");
      dispatch(textComment("data"))
    } catch (error) {
    }
  }
}